import { Overlay } from '@angular/cdk/overlay';
import { ComponentType } from '@angular/cdk/portal';
import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  matDialog = inject(MatDialog);

  private static instance: ConfirmDialogService | null = null;
  constructor(private overlay: Overlay) {
    ConfirmDialogService.instance = this;
  }
  public static getInstance() {
    return ConfirmDialogService.instance;
  }

  openDialog<T>(data: any, component: ComponentType<T>): Observable<boolean> {
    const { width, maxWidth, ...dialogData } = data ?? {};
    const scrollStrategy = this.overlay.scrollStrategies.close();

    return this.matDialog
      .open(component, {
        data: dialogData,
        width: width != null ? `${width}px` : undefined,
        maxWidth: maxWidth != null ? `${maxWidth}px` : undefined,
        scrollStrategy,
        disableClose: true,
      })
      .afterClosed();
  }
}
